import "./dom_extend";

export const Animation = {};

// Výchozí hodnoty
Animation.default = {};
Animation.default.duration = 500; // [ms]
Animation.default.display = "block"; // block, inline, inline-block, flex, ... atd.


//
// Pomocná funkce, která zajišťuje animaci. Pro animaci využíváme CSS3 transitions. Úkolem
// javascriptu je nastavit stav před, dát prohlížeči informaci o změně stavu, nastavit transitions
// a nastavit stav po. Prohlížeč vykoná animaci a na konci po sobě uklidíme.
//
// Všechny animace jdou rozdělit na kind = "in" (prvek chceme zobrazit) a kind = "out" (prvek chceme skrýt),
// animace pak mají fáze "initialize", "setUp", "run" a úklidovou "tearDown". Vhodnou volbou této čtveřice
// funkcí lze vytvořit různé animace, jako nyní implementované fadeIn/fadeOut a slideDown/slideUp.
//
// Funkce vrací Promise, tj. navázat na dokončenou animaci lze standardně přes "then()".
//
function animate(elements, kind, initialize, setUp, run, tearDown) {
	return new Promise(function(resolve, reject) {

		// Animujme celé pole prvků (převeďme proto samostatný prvek na jednoprvkové pole).
		// Pole testujeme přes existenci metody length, protože querySelectorAll funkce vrací svoji kolekci
		// nikoliv pole jako takové a toto je nejjednodušší způsob, jak otestovat, jestli v ruce držíme
		// obecně nějakou kolekci nebo ne.
		if (!(elements instanceof NodeList || elements instanceof Array)) {
			elements = [elements];
		}

		// V případě, že animace je typu "in", tj. budeme element zobrazovat, provedeme preprocessing
		// na test viditelnosti a nastavíme CSS vlastnost display.
		if (kind == "in") {
			// Odstraňme z pole ty prvky, které už jsou viditelné (abychom je neanimovali znovu).
			elements = Array.from(elements).filter(function(element) {
				return !element.isVisible()
			});

			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];

				// Odstraňme Bootstrap třídy, které znemožňují zobrazení prvku.
				element.classList.remove("d-none", "d-sm-none", "d-md-none", "d-lg-none", "d-xl-none");

				// Zjistěme, jaký display (block, flex, inline-block, ...) má prvek mít. Není-li k dispozici, nastavme výchozí hodnotu.
				element.style.removeProperty("display");
				var elementDisplay = getComputedStyle(element).display;
				if (elementDisplay == "none") {
					elementDisplay = Animation.default.display;
				}
				element.style.display = elementDisplay;
				element.style.visibility = "visible";
			}
		}

		// Samotná animace, kdy nejprve nastavíme počáteční vlastnosti elementu, vynutíme v prohlížeči přepočet,
		// nastavíme transitions a konečné vlatnosti elementu. Prohlížeč pak za nás sám element animuje.
		for (var i = 0; i < elements.length; ++i) {
			var element = elements[i];

			// Doplňující data, která mohou fáze setUp a run využít pro přenos nějaké užitečné informace (např. výšky prvku před a po animaci).
			var data = {};

			// Proveďme základní inicializaci animace.
			initialize(element, data);

			// Vyresetujme hodnoty.
			setUp(element, data);

			// Připravme prohlížeč na animování.
			element.offsetHeight; // Bez tohoto řádku animace nefunguje, toto "donutí" prohlížeč přepočítat vlastnostnosti prvku a spustit pozdější animaci.

			// Proveďme animaci
			element.style.transitionDuration = Animation.default.duration + "ms";
			run(element, data);
		}

		// Ukliďme po sobě.
		setTimeout(function() {
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];

				// Odstraňme CSS vlastnosti, přes které jsme animovali.
				element.style.removeProperty("transition-duration");
				element.style.removeProperty("transition-property");

				// V případě skrývací animace nastavme CSS display vlastnost.
				if (kind == "out") {
					element.style.display = "none";
				}
				else if (kind == "hide") {
					element.style.visibility = "hidden";
				}

				// Úklid.
				tearDown(element);
			}

			// Pokračujme dál (promise).
			resolve(elements);

		}, Animation.default.duration + 10); // Dejme nějakou časovou rezervu (10ms), ať pohodlně doběhne CSS animace a nedojde k nějakému poskočení.
	});
};


// *************************************************************************
// Zobrazení/skrytí prvků pomocí fade animace
// *************************************************************************

function fadeInitialize() {
	// Prázdná funkce, u fade animace nepotřebujeme znát žádné informace o prvku.
}

function fadeHidden(element, data) {
	element.style.opacity = 0;
}

function fadeVisible(element, data) {
	element.style.transitionProperty = "opacity";
	element.style.opacity = 1;
}

function fadeCleanAnimation(element) {
	element.style.removeProperty("opacity");
}

Animation.fadeIn = function(elements) {
	return animate(
		elements, "in",
		fadeInitialize,
		fadeHidden,
		fadeVisible,
		fadeCleanAnimation
	);
};

Animation.fadeOut = function(elements, onlyHide) {
	return animate(
		elements, onlyHide ? "hide" : "out",
		fadeInitialize,
		fadeVisible,
		fadeHidden,
		fadeCleanAnimation
	);
};


// *************************************************************************
// Zobrazení/skrytí prvků pomocí slide animace
// *************************************************************************

function slideInitialize(element, data) {
	// Zjistěme, jaká je výška elementu (skrze ni budeme animovat)
	data.height = element.offsetHeight;
}

function slideHidden(element, data) {
	element.style.overflow = "hidden";
	element.style.height = 0;
	element.style.paddingTop = 0;
	element.style.paddingBottom = 0;
	element.style.marginTop = 0;
	element.style.marginBottom = 0;
}

function slideVisible(element, data) {
	element.style.transitionProperty = "height, margin, padding";
	element.style.boxSizing = "border-box";
	element.style.height = data.height + "px";
}

function slideCleanAnimation(element) {
	element.style.removeProperty("height");
	element.style.removeProperty("overflow");
	element.style.removeProperty("box-sizing");
}

function slideCleanState(element) {
	element.style.removeProperty("padding-top");
	element.style.removeProperty("padding-bottom");
	element.style.removeProperty("margin-top");
	element.style.removeProperty("margin-bottom");
}

Animation.slideDown = function(elements) {
	return animate(
		elements, "in",
		slideInitialize,
		slideHidden,
		function(element, data) {
			slideCleanState(element);
			slideVisible(element, data);
		},
		slideCleanAnimation
	);
};

Animation.slideUp = function(elements, onlyHide) {
	return animate(
		elements, onlyHide ? "hide" : "out",
		slideInitialize,
		slideVisible,
		slideHidden,
		function(element) {
			slideCleanState(element);
			slideCleanAnimation(element);
		}
	);
};
